var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div", attrs: { id: "ms_header_downside" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "corp_information" } },
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2)
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { attrs: { id: "president_msg" } }, [
      _c("h2", [_vm._v("代表メッセージ")]),
      _vm._v(" "),
      _c("div", [
        _c("p", [
          _vm._v("\n              私たちが考える。新しい家具のカタチ。"),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n              日本のポンペイともいえる鳥取県・青谷上寺地遺跡からは、約2000年前に使われた木製建具や収納等の住宅設備が、当時のまま発掘されています。"
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n              丸太を意のままに割り、機能とフィルムを一体化させた創造性あふれる造形には、弥生人の生活に対する豊かな人間性が感じられます。"
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n              時は流れ、工業製品による「豊かさ」や「便利さ」を享受する現在社会。\n              家具や日用品の物量は爆発的に増え、量産品の激しい価格競争によって、本当に「価値のあるモノ」や「価値のあるコト」が見えにくい世の中になっていると感じています。\n              「もっと自分らしく快適な部屋で暮らしたい」「もっと自由に家族のライフスタイルを表現したい」"
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n              それは誰もが持っている普遍的な欲求だと思います。収納が自由になると住み心地は劇的に変わります。収納とはその部屋での生活を快適にするために欠かせない住宅設備なのです。"
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(
            "\n              寸法も、色素材も、引き出しも扉も、自由にプランできて、しかも低価格。私たちが提供したいのは、生活を支える「道具」と、それを手に入れる「仕組み」です。\n              家族のみんなが、そのストーリーを刻める、新しい「家具のカタチ」が始まります。\n            "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("運営会社概要")]),
      _vm._v(" "),
      _c("ul", { staticClass: "ul_corp_outline" }, [
        _c("li", [
          _c("div", [_vm._v("商号")]),
          _vm._v(" "),
          _c("div", [_vm._v("ドゥーマンズ株式会社 Domans, Inc.")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("所在地")]),
          _vm._v(" "),
          _c("div", [_vm._v("東京都渋谷区代々木 3-28-6 いちご西参道ビル １階")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("設立日")]),
          _vm._v(" "),
          _c("div", [_vm._v("2000年6月26日")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("電話番号")]),
          _vm._v(" "),
          _c("div", [_vm._v("03-5354-7671")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("資本金")]),
          _vm._v(" "),
          _c("div", [_vm._v("2億5733万円（2020年12月末日現在）決算期 12月")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("代表者")]),
          _vm._v(" "),
          _c("div", [_vm._v("二宮 健一")])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("主要株主")]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                経営陣"),
            _c("br"),
            _vm._v("\n                K&Pパートナーズ株式会社"),
            _c("br"),
            _vm._v("\n                株式会社キャンディル"),
            _c("br"),
            _vm._v(
              "\n                三菱UFJキャピタル株式会社\n              "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("主な事業内容")]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n                1. 製造連携システムのクラウドライセンス事業"
            ),
            _c("br"),
            _vm._v(
              "\n                2. 製造連携システムのカスタマイズライセンス事業\n              "
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("主要取引先")]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                ・株式会社ウッドワン"),
            _c("br"),
            _vm._v("\n                ・柏木工株式会社"),
            _c("br"),
            _vm._v("\n                ・住友林業クレスト株式会社"),
            _c("br"),
            _vm._v("\n                ・株式会社TJMデザイン"),
            _c("br"),
            _vm._v(
              "\n                ・パナソニック建設エンジニアリング株式会社"
            ),
            _c("br"),
            _vm._v("\n                ・株式会社LIXIL"),
            _c("br"),
            _vm._v("\n                ・その他"),
            _c("br"),
            _vm._v("\n                (五十音順・敬称略)\n              ")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("許認可、"), _c("br"), _vm._v("及び所属団")]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n                経済産業省 関東経済業局 新連携対策補助金支援事業"
            ),
            _c("br"),
            _vm._v("\n                東京建具協同組合"),
            _c("br"),
            _vm._v("\n                公益社団法人インテリア産業協会"),
            _c("br"),
            _vm._v("\n                キッチン・バス工業会"),
            _c("br"),
            _vm._v("\n                東京家具工業組合\n              ")
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("div", [_vm._v("関係会社")]),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n                ファニチャーメーカー株式会社"),
            _c("br"),
            _vm._v("\n                資本金：1,500万円"),
            _c("br"),
            _vm._v(
              "\n                事業内容：オーダー家具製造販売事業\n              "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h2", [_vm._v("アクセス")]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n            東京都渋谷区代々木 3-28-6 いちご西参道ビル １階"),
        _c("br"),
        _vm._v("\n            都営地下鉄新宿線「初台」駅より徒歩8分"),
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v("\n            Tel: 03-5354-7671"),
        _c("br"),
        _vm._v("\n            Fax: 03-5354-7672"),
        _c("br"),
        _vm._v("\n            フリーダイヤル: 0800-888-9955\n          ")
      ]),
      _vm._v(" "),
      _c("div", { attrs: { id: "gmap" } }, [
        _c("iframe", {
          staticStyle: { border: "0" },
          attrs: {
            src:
              "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12962.952115184788!2d139.691904!3d35.683452!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6b97f71ea432901e!2z44OJ44Kl44O844Oe44Oz44K6!5e0!3m2!1sja!2sjp!4v1634889030888!5m2!1sja!2sjp",
            width: "600",
            height: "450",
            allowfullscreen: "",
            loading: "lazy"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d67bdf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d67bdf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcCorpInformation.vue
// module id = null
// module chunks = 